import React from 'react';
import HandsImg from '../../imgs/hands.jpg';
import ConnorPianoImg from '../../imgs/connorpiano.jpeg';
import TableImg from '../../imgs/table.jpg';

const BreathworkAndBrunch: React.FC = () => {
  return (
    <div className="min-h-screen bg-lighttan pt-28">
        <h1 className="text-4xl font-bold text-darkgreentext mb-12 text-center">
          Breathwork and Brunch with Connor on the Keys
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 px-4">
            <img
            src={HandsImg}
            alt="Hands"
            className="w-full h-[500px] object-cover object-top rounded-lg shadow-lg"
            />
            <img
            src={ConnorPianoImg}
            alt="Connor Piano"
            className="w-full h-[500px] object-cover object-center rounded-lg shadow-lg"
            />
            <img
            src={TableImg}
            alt="Table"
            className="w-full h-[500px] object-cover object-top rounded-lg shadow-lg"
            />
        </div>

      <div className="max-w-4xl mx-auto px-8 py-16 text-center">
        <p className="text-xl text-darkgreentext leading-relaxed">
        Join Sean Clark, certified Wim Hof Method instructor, for this special journey with the breath to classical piano played in the Great Room of his home built in 1899.
        </p>
      </div>
      <div className="flex justify-center pb-8">
        <a
          href="https://calendly.com/seanmotiv8living/breathwork-piano-community-potluck?back=1&month=2026-03"
          className="px-6 py-3 bg-darkgreentext text-white rounded-lg font-bold text-xl hover:bg-greenbutton transition"
        >
          Sign Up Now
        </a>
      </div>
    </div>
  );
};

export default BreathworkAndBrunch;
